import React, { useState, useEffect } from 'react';
import { Grid, TextField, Button, Typography, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import apiService from '../../service/apiService';

const AddPgDataForm = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    pgName: "",
    ifscCode: "",
    bankName: "",
    accountNumber: "",
    villageId: 0,
    districtId: 0,
    blockId: 0,
    gpId: 0,
    pGFId: 0,
    fpoId: 0,
    presidentName: "",
    presidentMobileNo: "",
    secretaryName: "",
    secretaryMobileNo: "",
    availableBalance: 0,
    coreactivities: "",
  });

  const [facilitators, setFacilitators] = useState([]);
  const [fpoList, setFpoList] = useState([]);
  const [dists, setAllDists] = useState([]);
  const [blocks, setBlocks] = useState([]);
  const [gps, setGps] = useState([]);
  const [vlgs, setVlgs] = useState([]);
  const [distselectable, setDistselectable] = useState(false);
  const [blkselectable, setBlkselectable] = useState(false);
  const loginData = JSON.parse(localStorage.getItem("loginData"));
  const [dist, setDist] = useState(loginData?.districtId ? loginData.districtId : 0);
  const [blk, setBlk] = useState(loginData?.blockId ? loginData.blockId : 0);
  const [gpid, setGpid] = useState(0);
  const isDistCoordinator = loginData?.districtCoordinatorsId !== null;
  const isBlockCoordinator = loginData?.blockCoordinatorsId !== null;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  const handleSubmit = async (event) => {
    const isConfirmed = window.confirm("Are you sure you want to create this PG ?");

    if (!isConfirmed) {
      return;
    }
    event.preventDefault();
    try {
      const response = await apiService.post('/producer-groups/create', formData);
      console.log('Form submitted successfully:', response.data);
      navigate(-1);
    } catch (error) {
      console.error('Error submitting the form:', error);
    }
  };
  const fetchFacilitators = async () => {
    try {
      const response = await apiService.get(
        "/producer-group-facilitators/get-all"
      );
      setFacilitators(response.data);
    } catch (error) {
      console.error("Error fetching facilitators:", error);
    }
  };
  const fetchFpoList = async () => {
    try {
      const response = await apiService.get("/fpo/get-all");
      setFpoList(response.data);
    } catch (error) {
      console.error("Error fetching FPO list:", error);
    }
  };
  const fetchAllDist = async () => {
    try {
      const response = await apiService.get('/districts/get-all');
      setAllDists(response.data);
    } catch (error) {
      console.error('Error fetching districts:', error);
    }
  };

  const fetchBlocks = async () => {
    try {
      const response = await apiService.get(`/master/get-block-by-district/${dist}`);
      setBlocks(response.data.body.blocks);
    } catch (error) {
      console.error("Error fetching blocks:", error);
    }
  };

  const fetchGP = async () => {
    try {
      const response = await apiService.get(`/master/get-gp-by-block/${blk}`);
      setGps(response.data.body.gpList);
    } catch (error) {
      console.error("Error fetching blocks:", error);
    }
  };

  const fetchVlg = async () => {
    try {
      const response = await apiService.get(`/master/get-village-by-gp/${gpid}`);
      setVlgs(response.data.body);
    } catch (error) {
      console.error("Error fetching blocks:", error);
    }
  };

  useEffect(() => {
    fetchFacilitators();
    fetchFpoList();
    fetchAllDist();

  }, []);
  useEffect(() => {
    if (dist > 0) {
      fetchBlocks();
    }
  }, [dist]);

  useEffect(() => {
    if (blk > 0) {
      fetchGP();
    }
  }, [blk]);

  useEffect(() => {
    if (gpid > 0) {
      fetchVlg();
    }
  }, [gpid]);

  const handleCancel = () => {
    navigate(-1);
  };

  const [isSaveDisabled, setIsSaveDisabled] = useState(true);

  useEffect(() => {
    const requiredFields = [
      "pgName",
      "gpId",
      "villageId",
      "presidentName",
      "presidentMobileNo",
      "secretaryName",
      "secretaryMobileNo",
      "bankName",
      "accountNumber",
      "ifscCode",
      "coreactivities",

    ];

    const isAnyFieldEmpty = requiredFields.some(
      (field) => !formData[field] || formData[field] === 0 || formData[field] === "" || blk === 0 || dist === 0
    );

    setIsSaveDisabled(isAnyFieldEmpty);
  }, [formData, blk, dist]);
  return (
    <form onSubmit={handleSubmit}>
      <div className='mx-3 mt-2 d-flex justify-content-between'>
        <h4 className='text-bold'>Add Producer Group Data</h4>
        <p><span className='text-danger text-bold' style={{ fontSize: "18px" }}>*</span> mark fields are mandetory</p>
      </div>
      <Grid container spacing={2} sx={{ paddingX: 2 }}>
        <Grid item xs={12} md={6}>
          <TextField
            name="pgName"
            label={
              <>
                Producer Group Name <span style={{ color: "red" }}>*</span>
              </>
            }
            fullWidth
            value={formData.pgName}
            onChange={handleChange}
            margin="dense"
          />
          <FormControl fullWidth margin="dense">
            <InputLabel id="dist-label">Dist<span style={{ color: "red" }}> *</span></InputLabel>
            <Select
              labelId="dist-label"
              label={
                <>
                  Dist <span style={{ color: "red" }}>*</span>
                </>
              }
              name="districtId"
              value={formData.districtId || dist}
              onChange={(e) => {
                setDist(e.target.value);
                setFormData((prev) => ({ ...prev, districtId: e.target.value }));
              }}
              disabled={isDistCoordinator}
              variant="outlined"
            >
              <MenuItem value={0} disabled>Select District</MenuItem>
              {dists.map((d) => (
                <MenuItem key={d.districtId} value={d.districtId}>
                  {d.districtName}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl fullWidth margin="dense">
            <InputLabel id="block-label">Block<span style={{ color: "red" }}> *</span></InputLabel>
            <Select
              labelId="block-label"
              label={
                <>
                  Block <span style={{ color: "red" }}>*</span>
                </>
              }
              name="blockId"
              value={formData.blockId || blk}
              onChange={(e) => {
                setBlk(e.target.value);
                setFormData((prev) => ({ ...prev, blockId: e.target.value }));
              }}
              disabled={isBlockCoordinator}
              variant="outlined"
            >
              <MenuItem value={0} disabled>Select Block</MenuItem>
              {blocks.map((b) => (
                <MenuItem key={b.blockId} value={b.blockId}>
                  {b.blockName}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl fullWidth margin="dense">
            <InputLabel id="gp-label">GP<span style={{ color: "red" }}> *</span></InputLabel>
            <Select
              labelId="gp-label"
              label={
                <>
                  GP <span style={{ color: "red" }}>*</span>
                </>
              }
              value={formData.gpId}
              name="gpId"
              onChange={(e) => { setGpid(e.target.value); handleChange(e); }}
              variant="outlined"
            >
              <MenuItem value={0} disabled>Select GP</MenuItem>
              {gps.map((d) => (
                <MenuItem key={d.gpId} value={d.gpId}>
                  {d.gpName}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl fullWidth margin="dense">
            <InputLabel id="village-label">Village<span style={{ color: "red" }}> *</span></InputLabel>
            <Select
              labelId="village-label"
              label={
                <>
                  Village <span style={{ color: "red" }}>*</span>
                </>
              }
              name="villageId"
              value={formData.villageId || 0}
              onChange={handleChange}
              variant="outlined"
            >
              <MenuItem value={0} disabled>Select Village</MenuItem>
              {vlgs.map((v) => (
                <MenuItem key={v.villageId} value={v.villageId}>
                  {v.villageName}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl fullWidth margin="dense">
            <InputLabel id="facilitator-label">Facilitator<span style={{ color: "red" }}> *</span></InputLabel>
            <Select
              labelId="facilitator-label"
              label={
                <>
                  Facilitator <span style={{ color: "red" }}>*</span>
                </>
              }
              name="pGFId"
              value={formData.pGFId || 0}
              onChange={handleChange}
              variant="outlined"
            >
              <MenuItem value={0} disabled>Select PGF</MenuItem>
              {facilitators.map((f) => (
                <MenuItem
                  key={f.userId}
                  value={f.userId}
                >
                  {f.userName}
                </MenuItem>
              ))}
            </Select>
          </FormControl>



          <FormControl fullWidth margin="dense">
            <InputLabel id="fpo-label">
              FPO<span style={{ color: "red" }}> *</span>
            </InputLabel>
            <Select
              labelId="fpo-label"
              name="fpoId"
              value={formData.fpoId || 0}
              onChange={handleChange}
              variant="outlined"
            >
              <MenuItem value={0} disabled>Select FPO</MenuItem>
              {Array.isArray(fpoList) && fpoList.map((fpo) => (
                <MenuItem key={fpo.fpoid} value={fpo.fpoid}>
                  {fpo.fponame}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <TextField
            name="coreactivities"
            label={
              <>
                Core Activities<span style={{ color: "red" }}>*</span>
              </>
            }
            fullWidth
            value={formData.coreactivities}
            onChange={handleChange}
            margin="dense"
          />

        </Grid>

        {/* Right Column */}
        <Grid item xs={12} md={6}>
          <TextField
            name="presidentName"
            label={
              <>
                President Name <span style={{ color: "red" }}>*</span>
              </>
            }
            fullWidth
            value={formData.presidentName}
            onChange={handleChange}
            margin="dense"
          />
          <TextField
            name="presidentMobileNo"
            label={
              <>
                President Contact Number <span style={{ color: "red" }}>*</span>
              </>
            }
            fullWidth
            value={formData.presidentMobileNo}
            onChange={handleChange}
            margin="dense"
          />
          <TextField
            name="secretaryName"
            label={
              <>
                Secretary Name <span style={{ color: "red" }}>*</span>
              </>
            }
            fullWidth
            value={formData.secretaryName}
            onChange={handleChange}
            margin="dense"
          />
          <TextField
            name="secretaryMobileNo"
            label={
              <>
                Secretary Contact Number <span style={{ color: "red" }}>*</span>
              </>
            }
            fullWidth
            value={formData.secretaryMobileNo}
            onChange={handleChange}
            margin="dense"
          />
          <TextField
            name="bankName"
            label={
              <>
                Bank Name <span style={{ color: "red" }}>*</span>
              </>
            }
            fullWidth
            value={formData.bankName}
            onChange={handleChange}
            margin="dense"
          />
          <TextField
            name="accountNumber"
            label={
              <>
                Account Number <span style={{ color: "red" }}>*</span>
              </>
            }
            fullWidth
            value={formData.accountNumber}
            onChange={handleChange}
            margin="dense"
          />
          <TextField
            name="ifscCode"
            label={
              <>
                IFSC Code <span style={{ color: "red" }}>*</span>
              </>
            }
            fullWidth
            value={formData.ifscCode}
            onChange={handleChange}
            margin="dense"
          />
          <TextField
            name="availableBalance"
            label="Available Balance"
            fullWidth
            value={formData.availableBalance}
            onChange={(e) => {
              setFormData((prev) => ({ ...prev, availableBalance: Number(e.target.value) }));
            }}
            margin="dense"
          />
        </Grid>

        {/* Submit and Cancel Buttons */}
        <Grid item xs={12}>
          <Button
            variant="contained"
            color="primary"
            type="submit"
            style={{ marginRight: '10px' }}
            disabled={isSaveDisabled}
          >
            Submit
          </Button>
          <Button variant="outlined" color="secondary" onClick={handleCancel}>
            Cancel
          </Button>
        </Grid>
      </Grid>
    </form>
  );
};

export default AddPgDataForm;
